export const engagementLandingPagesAppGroupIdCustomDomainLimits =
  "/engagement/landing_pages/:app_group_id/custom_domain_limits";
